import { all, fork } from 'redux-saga/effects'

import watchDataFetch from './watchers/dataFetch'

export default function* root() {
  yield all([fork(watchDataFetch)])
}
